import { styled } from '@mui/material';

export const VideoPlayerCardStyled = styled('video')(({ theme }) => ({
  width: '92px !important',
  height: '65px !important',
  borderRadius: theme.spacing(1),
  cursor: 'pointer',
  background: theme.palette.dark.dark_1,
}));
